import { millisecondsInHour, daysInWeek } from 'date-fns/constants';
import { DAYS, HOURS, WEEKS } from "../constants";

const HOURS_IN_DAY = 24;

export const getMsValue = (value, range) => {
    switch (range) {
        case HOURS:
            return value * millisecondsInHour;
        case DAYS:
            return value * millisecondsInHour * HOURS_IN_DAY;
        default:
            return value * millisecondsInHour * HOURS_IN_DAY * daysInWeek;
    }
}


export const getMsTime = (dateTime = null) => {
    if (!dateTime) {
        return null;
    }
    const date = new Date(dateTime);
    return date.getTime();
}

export const getTomorrowDate = () => {
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    return tomorrow;
}

export const getTodaysMinTime = () => {
    const dateAndTime = new Date();
    dateAndTime.setHours(dateAndTime.getHours() + 2, 0, 0, 0);
    return dateAndTime;
}

export const getRangeAndValue = (offset) => {
    const hoursOffset = offset / millisecondsInHour;
    if ((hoursOffset % HOURS_IN_DAY != 0) || hoursOffset < HOURS_IN_DAY) {
        return { range: HOURS, offset: hoursOffset };
    }
    const daysOffset = hoursOffset / HOURS_IN_DAY;
    if ((daysOffset % daysInWeek != 0) || daysOffset < daysInWeek) {
        return { range: DAYS, offset: daysOffset };
    }
    const weeksOffset = Math.trunc(daysOffset / daysInWeek);
    return { range: WEEKS, offset: weeksOffset };
}